module.exports = __webpack_public_path__ + "img/spinner.579b02c9.gif";